// Spanish translations
export const es = {
  // Header
  header: {
    title: 'Laboratorio MicroGPT',
    subtitle: 'Aprende microgpt de forma interactiva',
    level: 'Nivel',
    params: 'parámetros',
    badges: 'insignias',
    train: 'Entrenar',
    star: 'Estrella'
  },

  // Navigation
  nav: {
    curriculum: 'Currículo',
    content: 'Contenido',
    visualization: 'Visualización'
  },

  // Levels
  levels: {
    completed: 'Completado',
    locked: 'Bloqueado',
    current: 'Nivel Actual'
  },

  // Buttons
  buttons: {
    complete: 'Completar Nivel',
    startLearning: 'Comenzar a Aprender',
    trainAgain: 'Entrenar de Nuevo',
    reset: 'Reiniciar',
    close: 'Cerrar',
    cancel: 'Cancelar',
    confirm: 'OK',
    showHint: 'Mostrar Pista',
    showSolution: 'Mostrar Solución',
    runCheck: 'Ejecutar y Verificar',
    randomize: 'Aleatorizar'
  },

  // Training Experience
  training: {
    title: 'Entrenar MicroGPT',
    intro: 'Observa un modelo de lenguaje entrenar y generar texto en tiempo real',
    starting: 'Iniciando entrenamiento...',
    training: 'Entrenando...',
    generating: 'Generando muestras...',
    complete: '¡Entrenamiento Completo!',
    lossLabel: 'Pérdida',
    stepLabel: 'Paso',
    generatedNames: 'Nombres Generados (¡Alucinados!)',
    explanation: '¡Estos nombres fueron alucinados por el modelo - nunca los ha visto antes!',
    pipeline: 'El Pipeline Completo de MicroGPT',
    comparison: 'De Esta Demo a ChatGPT',
    thisDemo: 'Esta Demo',
    chatgpt: 'ChatGPT',
    sameAlgorithm: '¡Mismo algoritmo, diferente escala!'
  },

  // About Dialog
  about: {
    title: 'Acerca de MicroGPT',
    subtitle: 'La esencia de los grandes modelos de lenguaje',
    whatIs: '¿Qué es MicroGPT?',
    whatIsDesc: 'MicroGPT es una implementación mínima de un modelo de lenguaje estilo GPT...',
    whatYoullLearn: 'Lo que Aprenderás',
    fromMicroToMega: 'De Micro a Mega',
    chatgptConnection: 'La Conexión con ChatGPT',
    resources: 'Recursos',
    resetProgress: 'Reiniciar Todo el Progreso',
    resetProgressDesc: 'Borrar todos los niveles completados e insignias obtenidas',
    resetConfirm: '¿Estás seguro de que quieres reiniciar todo el progreso? Esto borrará los niveles completados y las insignias obtenidas.'
  },

  // Code Exercise
  exercise: {
    description: 'Descripción',
    template: 'Plantilla de Código',
    hint: 'Pista',
    solution: 'Solución',
    useSolution: 'Usar esta solución',
    attempts: 'intento',
    attemptsPlural: 'intentos',
    checking: 'Verificando...',
    loading: 'Cargando entorno Python...',
    testPassed: 'Prueba aprobada',
    testFailed: 'Prueba fallida',
    allTestsPassed: '¡Todas las pruebas aprobadas!',
    someTestsFailed: 'Algunas pruebas fallaron',
    tabSpaces: 'Tab = 4 espacios'
  },

  // Notifications
  notifications: {
    badgeEarned: 'Insignia obtenida',
    levelComplete: '¡Nivel completado!',
    readyToLearn: '¡Listo para aprender cómo funciona!'
  },

  // Theme
  theme: {
    chooseTheme: 'Elegir Tema',
    selectScheme: 'Selecciona tu esquema de color preferido',
    dark: 'Oscuro',
    light: 'Claro'
  },

  // Common
  common: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información'
  }
};
